import React from 'react';
import styled from 'styled-components';
import { Card } from 'antd';

interface TemplateCardProps {
  title: string;
  extra?: React.ReactNode;
}

const TCard = styled(Card)`
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  .ant-card-body {
    padding: 12px 24px;
    display: flex;
    flex-direction: column;
    min-height: 330px;
    flex-grow: 1;
  }
  .ant-card-head-title {
    padding: 20px 0px;
  }
`;

const TemplateCard: React.FC<React.PropsWithChildren<TemplateCardProps>> = ({
  title,
  extra,
  children,
}) => (
  <TCard title={title} extra={extra}>
    {children}
  </TCard>
);

export default TemplateCard;
